/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { proposalsOverTimeGetApiV3ProposalsOverTime } from "../../funcs/proposalsOverTimeGetApiV3ProposalsOverTime.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3ProposalsOverTimeRequest$inboundSchema,
};

export const tool$proposalsOverTimeGetApiV3ProposalsOverTime: ToolDefinition<
  typeof args
> = {
  name: "proposals-over-time-get-api-v3-proposals-over-time",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await proposalsOverTimeGetApiV3ProposalsOverTime(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
